// PublicationsList.js
import React, { useState, useEffect } from 'react';
import Publications from './Publications';
import PaginationControls from './PaginationControls';
import { InfinitySpin } from 'react-loader-spinner';

function PublicationsList({ publications }) {
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const itemsPerPage = 3;

  const sortedPublications = publications.sort((a, b) => (a.id < b.id ? 1 : -1));
  const displayedPublications = sortedPublications.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  useEffect(() => {
    // simulate a delay to demonstrate the loading spinner
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  if (isLoading) {
    return (
      <div className="text-center mt-5">
        <InfinitySpin width='200' color="#0051AD" />
      </div>
    );
  }

  return (
    <section id="publications" className="py-6" style={{ backgroundColor: 'var(--bg-surface)' }}>
      <div className="max-w-5xl mx-auto px-6">
        <div className="title-box text-center section-header-reveal mb-6">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 tracking-tight" style={{ color: 'var(--text-primary)' }}>
            Publications
          </h2>
          <div className="w-16 h-1 mx-auto mb-6 rounded-full" style={{ backgroundColor: 'var(--primary)' }} />
          <p className="text-lg leading-relaxed max-w-2xl mx-auto text-reveal reveal-delay-1" style={{ color: 'var(--text-secondary)' }}>
            Research contributions in machine learning, computer vision, and deep learning — published in peer-reviewed journals and conferences.
          </p>
        </div>

        <div className="space-y-10">
          {displayedPublications.map((publication, index) => (
            <div key={publication.id} className={`card-reveal reveal-delay-${Math.min(index + 1, 8)}`}>
              <Publications
                title={publication.title}
                imageUrl={publication.imageUrl}
                description={publication.description}
                link={publication.link}
                authors={publication.authors}
                journal={publication.journal}
                type={publication.type}
                keywords={publication.keywords}
                date={publication.date}
                abstract={publication.abstract}
                podcasts={publication.podcasts}
                schemaData={{
                  '@context': 'https://schema.org',
                  '@type': 'ScholarlyArticle',
                  'headline': publication.title,
                  'author': publication.authors?.map(name => ({ '@type': 'Person', name })),
                  'url': publication.link
                }}
              />
            </div>
          ))}
        </div>

        {publications.length > itemsPerPage && (
          <div className="mt-12">
            <PaginationControls
              pageCount={Math.ceil(publications.length / itemsPerPage)}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </section>
  );
}

export default PublicationsList;
